export default __webpack_public_path__ + "static/media/recommend-icon.afe3bedc.svg";